import { useEffect } from 'react';
import { LDObserve } from '@launchdarkly/observability';
import { useFlags } from 'launchdarkly-react-client-sdk';

const ObservabilityStart = () => {
  const flags = useFlags();

  useEffect(() => {
    const observabilityEnabled = flags.observability;
    if (observabilityEnabled) {
      LDObserve.start();
    }
  }, [flags.observability]);

  return null;
};

export default ObservabilityStart;
